import { format } from "date-fns";

export const formatDate = (date: string): string => {
  return date ? format(new Date(date), "PPPppp") : "";
};

export const renderArrayAsString = (vals: readonly (string | null)[] | null | undefined): string | null => {
  if (vals === null || vals === undefined) return "";
  if (vals.length === 1) {
    return vals[0];
  } else {
    const val_list = vals.reduce((x, accum) => accum + ", " + x, "");
    return val_list ? val_list.slice(0, -2) : "";
  }
};

export const toProperCase = (str: string): string => {
  const lowerCase = str.toLowerCase();
  const properCase = lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1);
  return properCase;
};

export const formatBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = Math.max(0, decimals);
  const sizes = ["Bytes", "KB", "MB", "GB"];

  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
